var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.payments,"headers":_vm.invoiceHeaders,"hide-default-footer":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.appointment_code",fn:function(ref){
var item = ref.item;
return [(item.appointment)?_c('a',{attrs:{"href":("/admin-appointment/" + (item.appointment.id)),"target":"_blank"}},[_vm._v(" "+_vm._s(item.appointment.code)+" ")]):_c('span',[_vm._v("---")])]}},{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.created_at))+" ")]}},{key:"item.description",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.description(item.description))+" ")]}},{key:"item.payment_type",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.paymentType(item))+" ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatMoney(item.total))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }